export function setEventTypes (state, eventTypes) {
	state.eventTypes = [ ...eventTypes ];
}
